var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9261",
    "data-name": "Group 9261",
    transform: "translate(-452 -6143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3369",
    "data-name": "Rectangle 3369",
    width: 34,
    height: 34,
    rx: 17,
    transform: "translate(452 6143)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M13.1,6.335c.009.13.009.259.009.389a8.454,8.454,0,0,1-8.512,8.512A8.455,8.455,0,0,1,0,13.894a6.189,6.189,0,0,0,.722.037,5.992,5.992,0,0,0,3.714-1.278,3,3,0,0,1-2.8-2.075,3.773,3.773,0,0,0,.565.046,3.164,3.164,0,0,0,.787-.1,2.992,2.992,0,0,1-2.4-2.936V7.549a3.013,3.013,0,0,0,1.352.38,3,3,0,0,1-.926-4A8.5,8.5,0,0,0,7.188,7.058a3.377,3.377,0,0,1-.074-.685,2.995,2.995,0,0,1,5.178-2.047,5.89,5.89,0,0,0,1.9-.722,2.984,2.984,0,0,1-1.315,1.649A6,6,0,0,0,14.6,4.789a6.431,6.431,0,0,1-1.5,1.547Z",
    transform: "translate(461.701 6150.69)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.8ee2aa2fccc9ccf4f9bb8fe1a04f4575.svg";
export { ForwardRef as ReactComponent };